/**
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { Component } from 'react';
import Float from 'components/UI/Float';
import './StudentInfoFloat.scss';
import { Button } from 'components/UI';
import StudentInfoDock from 'template/Docks/StudentInfo';
import Loading from 'components/UI/Loading'

class StudentInfoFloat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      studentInfo: props.studentInfo
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.studentInfo !== this.props.studentInfo){
      this.setState({studentInfo: nextProps.studentInfo});
    }
  }
  render() {
    let {
      show,
      target,
      onCloseFloat,
    } = this.props;

    return (
      <Float
        container={global['--classtop-main-section']}
        show={show}
        target={target}
        floatWidth={250}
        onCloseFloat={onCloseFloat}
      >
        {this.renderFloatContent()}
      </Float>
    )
  }

  renderFloatContent() {
    const { lessonNumber, onCloseFloat, isLoading } = this.props;
    const {studentInfo} = this.state;
    
    return (
      <div className='studentInfo-float container-fluid'>
        <span className='header'>{__('Lesson {lesson_amount}, {student_amount} students', 'lesson', {lesson_amount: lessonNumber, student_amount: studentInfo.length})}</span>
        <i className='fa icon-cancel pull-right' onClick={onCloseFloat}></i>
        <ul>
          { !isLoading &&
            studentInfo.map((student, index) => {
              return <li key={index} onClick={() => {
                StudentInfoDock({id: student.student_id})
              }}>{student.student_name}</li>
            })
          }
          {
            isLoading && <Loading />
          }
        </ul>
      </div>
    );
  }

}

export default StudentInfoFloat;



// WEBPACK FOOTER //
// ./src/template/Floats/StudentInfoFloat/index.js